import './LandingTestimonials.scss';

import { Icon } from '@travelwin/core';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

import { ImageMedia } from '@/components/ImageMedia';
import { TestimonialItem } from '@/interfaces/cms';

import EmblaCarousel from '../Carousel/EmblaCarousel';
interface LandingTestimonialsProps {
  testimonialsArray: TestimonialItem[];
}

export const useMediaQuery = (query: string) => {
  const getInitialState = () => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  };

  const [matches, setMatches] = useState(getInitialState);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);

    setMatches(media.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
};

const LandingTestimonials = ({
  testimonialsArray,
}: LandingTestimonialsProps) => {
  const className = 'c-LandingTestimonials';

  const isDesktop = useMediaQuery('(min-width: 992px)');

  const options = {
    slidesToScroll: isDesktop ? 3 : 1,
    loop: false,
  };

  return (
    <div className={className}>
      <div className={`${className}__container`}>
        <div className={`${className}__tagline`}>
          <Trans
            i18nKey="landing.testimonials_title"
            defaults="We’ve Connected Millions Of <highlight>Happy Customers...</highlight>"
            components={{
              highlight: (
                <span className={`${className}__tagline--highlighted`} />
              ),
            }}
          />
        </div>
        <div className={`${className}__grouped-reviews-container`}>
          <EmblaCarousel options={options}>
            {testimonialsArray.map((testimonialItem: TestimonialItem) => (
              <div
                key={testimonialItem.id}
                className={`${className}__review-container`}
              >
                <div className={`${className}__review-text-container`}>
                  <div className={`${className}__review-stars`}>
                    <Icon name="fiveStarsIcon" />
                  </div>
                  <div className={`${className}__review-text`}>
                    {testimonialItem.content}
                  </div>
                  <div className={`${className}__reviewer`}>
                    {testimonialItem.author}
                  </div>
                </div>

                <div className={`${className}__review-source`}>
                  {testimonialItem.image && (
                    <div className={`${className}__review-source-logo`}>
                      <ImageMedia
                        media={testimonialItem.image}
                        sizes="(min-width: 768px) 33vw, 100vw"
                        loading="lazy"
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </EmblaCarousel>
        </div>
      </div>
    </div>
  );
};

export default LandingTestimonials;
